import React from 'react'
import {DeskingTableRowCell} from "./DeskingTableRowCell";

export const DeskingTableRow = (props) => {
    const {
        term,
        tier,
        hasTiers,
        isFirstTierRow,
        isGroupStart,
        quotesForRow,
        bestPaymentQuotes,
        sortByBestPayment,
        maxColumns,
        lenders,
        lowestPaymentKeys,
        creditScore,
        dealState,
        dealId,
        onSave,
    } = props

    const isCashDeal = dealState.is_purchase && dealState.is_one_pay
    const termLabel = isCashDeal ? '0' : term
    // Display only: tiers are kept as "T1"/"T2" everywhere (keys, lookups,
    // payloads); the grid column just shows the number.
    const tierLabel = /^T\d+$/.test(tier) ? tier.slice(1) : tier

    return (
        <tr className={isGroupStart ? 'group-start' : undefined}>
            {/* Per-row Term cell (no rowSpan — rowspan + position:sticky leaks on
                horizontal scroll). The number shows on the first row; borders are
                removed in CSS so the column still reads as one block per term. */}
            <td className={'term td-term'}>
                {isFirstTierRow ? termLabel : ''}
            </td>
            {
                hasTiers &&
                <td className={'tier td-tier'}>{tierLabel}</td>
            }
            {
                // Best Payment: cheapest-first cells (lender on each cell), padded
                // with empty fillers so every row spans all maxColumns columns.
                sortByBestPayment
                    ? [
                        ...bestPaymentQuotes.map(({ lender, quote }, idx) => (
                            <DeskingTableRowCell
                                key={`${lender}-${term}-${tier}-${idx}`}
                                quote={quote}
                                lender={lender}
                                term={term}
                                tier={tier}
                                showLender={true}
                                isPurchase={dealState.is_purchase}
                                dealId={dealId}
                                onSave={onSave}
                                creditScore={creditScore}
                                isLowestPayment={lowestPaymentKeys?.has(`${term}|${tier}|${lender}`)}
                            />
                        )),
                        ...Array.from(
                            { length: Math.max(0, maxColumns - bestPaymentQuotes.length) },
                            (_, i) => <td key={`bp-empty-${i}`} className={'quote empty'}/>
                        ),
                    ]
                    : lenders.map((lender) => {
                        const quote = quotesForRow[lender]
                        return <DeskingTableRowCell
                            key={`${lender}-${term}-${tier}`}
                            quote={quote}
                            lender={lender}
                            term={term}
                            tier={tier}
                            isPurchase={dealState.is_purchase}
                            dealId={dealId}
                            onSave={onSave}
                            creditScore={creditScore}
                            isLowestPayment={lowestPaymentKeys?.has(`${term}|${tier}|${lender}`)}
                        />
                    })
            }
        </tr>
    )
}
